const common = {
  Save: '保存',
  'Previous Step': '前へ',
  'Next Step': '次へ',
  Finish: '完了',
  Cancel: 'キャンセル',
  Confirm: '確認',
  'Unauthorized - title':
    '申し訳ありません。このページには現在アクセスできません。',
  'Unauthorized - description':
    'このページへのアクセスが必要な場合は、ストアオーナーに権限の付与を依頼してください。',
  'Saved successfully': '保存しました',
  'Failed to save': '保存に失敗しました',
  en: 'English',
  'zh-hant': '繁體中文',
  'zh-cn': '简体中文',
  vi: 'Tiếng Việt',
  th: 'ไทย',
  ja: '日本語',
  'General Error': '問題が発生しました。もう一度お試しください。',
};

export default common;
